module.exports = __webpack_public_path__ + "img/broadcast tower-dark-gray-matte.bd175f83.gif";